import { Outlet } from "react-router-dom";

function AppoinmentsMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default AppoinmentsMain;